/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:49:34
 * @Last Modified by: Felixx
 * @Last Modified time: 2020-11-09 09:43:44
 */
import template from '@/app/editor/sidebar/templates/gfElement/icon.html';

export const iconSettings = [
  {
    caption: 'Icon',
    type: 'text',
    name: 'choose-icon',
    id: 'choose-icon',
    class: 'gf_to-iconPicker',
    target: '.gf_icon-wrap',
    ref: 'html|html',
  },
  {
    name: 'icon-color',
    caption: 'Color',
    id: 'icon-color',
    type: 'text',
    class: 'gryff-color',
    target: '.gf_icon-wrap',
    ref: 'css|color',
  },
  {
    id: 'icon-size',
    name: 'icon-size',
    class: 'gf_to-range',
    caption: 'Size',
    type: 'input',
    min: '0',
    max: '100',
    step: '1',
    unit: 'px',
    mode: 'true',
    target: '.gf_icon-wrap',
    ref: 'css|font-size',
  },
  {
    name: 'icon-align',
    id: 'icon-align',
    class: 'gf_to-align',
    caption: 'Alignment',
    type: 'select',
    options: {
      left: 'Left',
      center: 'Center',
      right: 'Right',
    },
    mode: 'responsive-mode',
    target: '.elm',
    ref: 'class|align',
  },
  {
    caption: 'Link',
    type: 'group',
    items: [
      {
        name: 'editLink',
        caption: 'Icon Link',
        type: 'text',
        class: 'editLink',
        placeholder: 'https://your-shop.myshopify.com',
        default_value: '',
        target: '.elm a',
        ref: 'attr|herf',
      },
      {
        id: 'icon-target',
        name: 'iccon-target',
        caption: 'Open link In',
        type: 'select',
        options: {
          '': 'Current Tab',
          _blank: 'New Tab',
        },
        default_value: '',
        target: '.elm a',
        ref: 'attr|target',
      },
    ],
  },
  {
    name: 'extra_class',
    caption: 'Extra Class',
    type: 'text',
    desc: 'If you wish to style particular content element differently, then use this field to add a class name and then refer to it in your css file.',
    target: '.elm',
    ref: 'class|classname',
  },
];

export default {
  name: 'Icon',
  slug: 'icon',
  class: 'gf_icon-wrap',
  id: 'md-icon',
  html: template(),
  settings: iconSettings,
};
